@if (showGame) {
<app-backgrop>
  @if (!win) {
    <div class="grid grid-cols-3 grid-rows-3 border-5 male-1">
      @for (item of puzzleParts; track trackByItemId(i, item); let i = $index) {
        <div class="max-w-[30vw] w-68 h-68 max-h-[30vw] puzzle-tile landscape:max-w-[30vh] landscape:max-h-[30vh]"
              [ngClass]="getTileClass(item.name)"
              data-id="{{i}}"
              (pointerdown)="takePart($event, item)">
        </div>
      }
    </div>
  } @else {
    <picture>
      <source [srcset]="'./assets-compressed/categories/puzzle-game/' + gender + '/' + currentImage + '.webp'" type="image/webp">
      <img class="max-w-[90vw] w-204 shadow-[0_0_10px_10px_#fff]" [src]="'./assets-compressed/categories/puzzle-game/' + gender + '/' + currentImage + '.png'" alt="">
    </picture>
  }
</app-backgrop>
}